import { httpClient } from "@/services";
import requestKeys from "@/constants/requestKeys";
import { tripsListHeader } from "@/constants/defaultHeader";

export default {
	state: {
		tripsList: null,
		tripsFilters: null,
		tripsTotals: null,
		tripsLimit: null,
		tripsOrder: null,
		tripsSort: null,
		tripsTotal: null,
		exportLink: null,
		filtersTrips: null,
		paginationTrips: {},
		preloaderTotalsTrips: true,
	},
	mutations: {
		updateList(state, { trips, order, sort, limit, total }) {
			trips.forEach(item => item.children = []);
			state.tripsList = trips;
			state.tripsLimit = limit;
			state.tripsOrder = order;
			state.tripsSort = sort;
			state.tripsTotal = total;
		},
		updatePreloaderTotals(state, payload) {
			state.preloaderTotalsTrips = payload;
		},
		updateFilters(state, payload) {
			state.filtersTrips = payload.filter;
		},
		updateTotal(state, payload) {
			state.tripsTotals = payload;
		},
		updateLoads(state, { id, loads }) {
			const index = state.tripsList.findIndex(el => el.trip_id === id);
			state.tripsList[index].children = loads;
		},
		updateDelLoads(state, payload) {
			const index = state.tripsList.findIndex(el => el.trip_id === payload);
			state.tripsList[index].children = [];
		}
	},
	actions: {
		async getTripDelete({ dispatch }, id) {
			try {
				dispatch("actionPreloader", true);
				await httpClient.post(`/trips/delete/${ id }`,);
				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},
		async getLoadsDelTrip({ commit }, id) {
			commit('updateDelLoads', id);
		},
		async getListTrips({ commit, dispatch }, value) {
			try {
				dispatch("actionPreloader", true);
				const { data } = await httpClient.post("/trips", value);

				if (data && !data.status) {
					const settingsRaw = data.settings;
					let settingsList = [];

					if (Array.isArray(settingsRaw)) {
						settingsList = settingsRaw;
					} else if (settingsRaw && Array.isArray(settingsRaw.setting)) {
						settingsList = settingsRaw.setting;
					}

					const settingsItemWithLimit = settingsList.find(item => item && item.limit != null);
					const limitFromSettingsItems = settingsItemWithLimit ? settingsItemWithLimit.limit : null;

					let limitFromSettingsObject = null;
					if (settingsRaw && settingsRaw.limit != null) {
						limitFromSettingsObject = settingsRaw.limit;
					}

					let effectiveLimit = data.limit;
					if (limitFromSettingsObject != null) {
						effectiveLimit = limitFromSettingsObject;
					}
					if (limitFromSettingsItems != null) {
						effectiveLimit = limitFromSettingsItems;
					}

					commit("updateList", {
						...data,
						limit: effectiveLimit,
					});

					commit("updateSettings", {
						settings: settingsList,
						key: requestKeys.TRIPS,
						defaultHeader: tripsListHeader,
					});

					commit("updateSettingsOptions", {
						limit: effectiveLimit,
					});

					dispatch("actionPreloader", false);
				}
			} catch (e) {
				console.error(e);
			}
		},
		async getFiltersTrips({ commit }, value) {
			commit('updatePreloaderTotals', true);
			try {
				const { data } = await httpClient.post('/trips/filters', value);

				if (data) {
					commit('updateFilters', data);
				}
			} catch (e) {
				console.error(e);
			}
		},
		async getTotalTrips({ commit }, value) {
			try {
				const { data } = await httpClient.post(`/trips/statistics`, value);

				if (data && !data.status) {
					commit('updateTotal', data);
					commit('updatePreloaderTotals', false);
				}
			} catch (e) {
				console.error(e);
			}
		},
		async getLoadsTrip({ commit, dispatch }, id) {
			try {
				dispatch("actionPreloader", true);
				const { data } = await httpClient.post(`/trips/load/${ id }`);

				if (data && !data.status) {
					commit('updateLoads', { id, loads: data.loads });
					dispatch("actionPreloader", false);
				}
			} catch (e) {
				console.error(e);
			}
		},
		async getExport({ commit, dispatch, rootGetters }, value) {
			dispatch("actionPreloader", true);
			const { fileType } = value;

			try {
				let url = '/trips/files';
				if (value.setting) delete value.setting;
				if (fileType === 4) url = '/loads/export';
				if (fileType === 5) url = '/trips/export';
				if (fileType === 0) delete value.fileType;

				if (fileType === 4 || fileType === 5) {
					value.setting = rootGetters.settings
						.filter(item => item.value && item.settings)
						.map(item => item.value);
				}
				const { data } = await httpClient.post(url, value);
				if (data && !data.error) {
					commit('updateExportLink', data);
				} else {
					dispatch("setAlert", { type: "error", message: data.error });
				}
				dispatch("actionPreloader", false);
			} catch (e) {
				console.error('www', e);
			}
		},
	},
	getters: {
		tripsList: (s) => s.tripsList,
		tripsFilters: (s) => s.tripsFilters,
		tripsTotals: (s) => s.tripsTotals,
		tripsLimit: (s) => s.tripsLimit,
		tripsOrder: (s) => s.tripsOrder,
		tripsSort: (s) => s.tripsSort,
		tripsTotal: (s) => s.tripsTotal,
		filtersTrips: s => s.filtersTrips,
		paginationTrips: s => s.paginationTrips,
		exportLink: s => s.exportLink,
		preloaderFiltersTrips: s => s.preloaderFiltersTrips,
		preloaderTotalsTrips: s => s.preloaderTotalsTrips,
		tripDelete2: s => s.tripDelete2,
	}
};

